import React from 'react'

const SpinningLoader = () => (
  <div className='spinning-loader'>
    <div className='spinning-loader__spinner' />
  </div>
)

export default SpinningLoader
